import React from "react";

const DOC = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            fill="#4086F4"
            d="m30.889 10.438-6.701-1.876L22.273 2H8.872C7.286 2 6 3.26 6 4.813v26.375C6 32.74 7.286 34 8.872 34h19.145c1.586 0 2.872-1.26 2.872-2.813v-20.75Z"
        />
        <path
            fill="#4175DF"
            d="M30.889 10.438v20.75c0 1.553-1.286 2.812-2.872 2.812h-9.573V2h3.83l1.914 6.563 6.7 1.874Z"
        />
        <path
            fill="#80AEF8"
            d="M30.889 10.438h-6.701c-1.053 0-1.915-.844-1.915-1.876V2c.25 0 .498.094.67.281l7.659 7.5a.87.87 0 0 1 .287.656Z"
        />
        <path
            fill="#FFF5F5"
            d="M24.188 17.063H12.701a.947.947 0 0 1-.957-.938c0-.518.428-.938.957-.938h11.487c.53 0 .957.42.957.938a.947.947 0 0 1-.957.938Zm0 3.75H12.701a.947.947 0 0 1-.957-.938c0-.518.428-.938.957-.938h11.487c.53 0 .957.42.957.938a.947.947 0 0 1-.957.938Zm0 3.75H12.701a.947.947 0 0 1-.957-.938c0-.518.428-.938.957-.938h11.487c.53 0 .957.42.957.938a.947.947 0 0 1-.957.938Zm-3.829 3.75h-7.658a.947.947 0 0 1-.957-.938c0-.518.428-.938.957-.938h7.658c.53 0 .957.42.957.938a.947.947 0 0 1-.957.938Z"
        />
        <path
            fill="#E3E7EA"
            d="M18.444 28.313h1.915c.529 0 .957-.42.957-.938a.947.947 0 0 0-.957-.938h-1.915v1.875Zm0-3.75h5.744c.529 0 .957-.42.957-.938a.947.947 0 0 0-.957-.938h-5.744v1.875Zm0-3.75h5.744c.529 0 .957-.42.957-.938a.947.947 0 0 0-.957-.938h-5.744v1.875Zm0-3.75h5.744c.529 0 .957-.42.957-.938a.947.947 0 0 0-.957-.938h-5.744v1.876Z"
        />
    </svg>
);

export default DOC;
